module.exports = __webpack_public_path__ + "static/img/2.adca0a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news19/2.png
// module id = YJ48
// module chunks = 1